import styled from "styled-components";

export const ContainerHeader = styled.header`
  width: 100%;
  padding: 60px 4vw;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  @media (min-width: 1025px) {
    padding: 0 5vw;
  }
`;

export const LogoWrapper = styled.div`
  z-index: 1;

  @media (max-width: 1024px) {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const MenuIcon = styled.div`
  position: absolute;
  right: 16px;
  font-size: 28px;
  cursor: pointer;
  z-index: 20;

  @media (min-width: 1025px) {
    display: none;
  }

  img {
    width: 32px;
    height: 32px;
  }
`;

export const MenuOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.THEME.background};
  backdrop-filter: blur(6px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 40px;
  z-index: 99;

  @media (min-width: 1025px) {
    display: none;
  }
`;

export const MenuContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.CONSTANTS.XH * 3}px;

  a {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 38}px;
    color: ${({ theme }) => theme.THEME.white};
    font-family: "Inter";
    font-weight: 500;
    cursor: pointer;
    text-decoration: none;
    transition: 0.2s ease-in-out;

    &:hover {
      color: ${({ theme }) => theme.THEME.grayText};
      transform: scale(1.05);
    }
  }
`;

export const CloseIcon = styled.div`
  position: absolute;
  top: 85px;
  right: 24px;
  font-size: 2rem;
  color: ${({ theme }) => theme.THEME.white};
  cursor: pointer;
`;

export const MenuDesktop = styled.nav`
  display: none;

  @media (min-width: 1025px) {
    display: flex;
    gap: 2.5rem;
    align-items: center;
    margin-left: auto;

    a {
      font-size: ${({ theme }) => theme.CONSTANTS.XR * 8}px;
      color: ${({ theme }) => theme.THEME.white};
      cursor: pointer;
      transition: 0.2s ease-in-out;

      &:hover {
        color: ${({ theme }) => theme.THEME.grayText};
        transform: scale(1.08);
      }
    }
  }
`;

export const ProfileWrapper = styled.div`
  position: relative;
  margin-left: 20px;
`;

export const ProfileIcon = styled.div`
  cursor: pointer;

  img {
    width: 70%;
    object-fit: cover;
    transition: all 0.3s ease;
    &:hover {
      transform: scale(1.1);
      box-shadow: 0 0 10px ${({ theme }) => theme.THEME.neonBlue};
    }
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 42px;
  right: 0;
  background-color: ${({ theme }) => theme.THEME.background};
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 12px rgba(0, 217, 255, 0.2);
  border-radius: 10px;
  padding: 12px 0;
  list-style: none;
  z-index: 100;

  button {
    background: none;
    border: none;
    width: 100%;
    text-align: left;
    padding: 10px 16px;
    color: ${({ theme }) => theme.THEME.white};
    font-family: "Inter", sans-serif;
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 8}px;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover {
      background-color: rgba(255, 255, 255, 0.05);
    }
  }
`;
